import { CommandBarAction } from 'owa-mail-commandbar-actions/lib/CommandBarAction';
import { createStore } from 'satcheljs';
import CommandBarStore from './schema/CommandBarStore';

const defaultCommandBarStore = {
    surfaceActions: [
        CommandBarAction.Reply,
        CommandBarAction.Delete,
        CommandBarAction.Archive,
        CommandBarAction.Junk,
        CommandBarAction.Sweep,
        CommandBarAction.Move,
        CommandBarAction.Categorize,
        CommandBarAction.Snooze,
        CommandBarAction.Undo,
    ],
    overflowActions: [
        CommandBarAction.MarkReadUnread,
        CommandBarAction.FlagUnflag,
        CommandBarAction.PinUnpin,
        CommandBarAction.IgnoreUnignore,
        CommandBarAction.CreateRule,
        CommandBarAction.Print,
        CommandBarAction.Translate,
        CommandBarAction.ShowImmersiveReader,
        CommandBarAction.AssignPolicy,
    ],
    isEditing: false,
};

export const getStore = createStore<CommandBarStore>('commandBar', defaultCommandBarStore);
export default getStore();
